import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext({
  ordersEnabled: null,
  ordersDisabledMessage: "",
  loading: true,
  refresh: () => {},
});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {
      // Jei nepavyko gauti — saugiai laikom užsakymus IŠJUNGTUS
      setSettings({ orders_enabled: false, orders_disabled_message: "Užsakymai laikinai negalimi." });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SettingsContext.Provider
      value={{
        // null = dar kraunasi (kad nemirgėtų ir neleistų pateikti užsakymo per anksti)
        ordersEnabled: settings ? !!settings.orders_enabled : null,
        ordersDisabledMessage: settings?.orders_disabled_message || "Užsakymai laikinai negalimi.",
        // Hero gijų animacijos parametrai (numatytieji, jei DB dar neturi)
        hero: {
          ryskumas: settings?.hero_ryskumas ?? 1.6,
          svytejimas: settings?.hero_svytejimas ?? 1.5,
          storis: settings?.hero_storis ?? 1.15,
        },
        loading,
        refresh: load,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
